import { render, staticRenderFns } from "./AdministratorDetails.vue?vue&type=template&id=3dad8d9e&"
import script from "./AdministratorDetails.vue?vue&type=script&lang=js&"
export * from "./AdministratorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports